import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { EnvService, REFRESH_QUERY_PARAM, RXHUB_APP_NAME, RXHUB_BASE_URL } from '@enliven/angular';
import { Observable, of } from 'rxjs';
import { E360SessionService } from '../services/e360-session.service';
import { E360UserService } from '../services/e360-user.service';

export const frameSourceResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): Observable<string> => {
  const e360SessionService = inject(E360SessionService);
  const envService: EnvService = inject(EnvService);
  const e360UserService: E360UserService = inject(E360UserService);

  let e360Url: string = e360SessionService.session.cognito.websiteBaseUrl;
  const currentPluginAppRoutePieces: string[] = _state.url.replace('/app/', '').split('/'); // ie) ['storemgtapp', 'stores', 'edit', '123-abc' ]
  let pluginAppBaseUrl: string = currentPluginAppRoutePieces[0]; // ie) 'storemgtapp'
  let pluginAppDeepLink = null;

  if (pluginAppBaseUrl.includes('?')) {
    const embeddedAppQueryParams: string[] = pluginAppBaseUrl.split('?'); // ie ['internalcommsapp', 'function=viewdetails&id=<announcementid>']
    pluginAppBaseUrl = embeddedAppQueryParams[0];
    pluginAppDeepLink = embeddedAppQueryParams[1];
  }

  // Some embedded apps are no longer under the CIS AWS Cloudfront distribution
  // this checks those specific apps and uses the embedded module's default url for the organization
  // comment the below if statement out for local dev of the embedded app to be hosted in the shell app iframe
  if (pluginAppBaseUrl === RXHUB_BASE_URL) {
    const userModuleAccess = e360UserService.user.modules.find(m => m.name === RXHUB_APP_NAME);
    console.log(userModuleAccess.url);

    const moduleUrl = userModuleAccess?.url;
    // example for RX HUB URL ... https://rxhub.mtm.d.platform.enlivenhealth.co
    e360Url = moduleUrl || e360Url;
  }

  // Develop a plugin app locally and host it in E360. Start both this app and your plugin app, then replace the below string with the relevant plugin base URL (ie - 'admin')
  if (envService.isLocal && pluginAppBaseUrl === '<INSERT_APP_BASE_URL_HERE>') {
    e360Url = 'http://localhost:4201';
  }

  let iframeUrl: string = `${e360Url}/${pluginAppBaseUrl}`; // ie) https://app.d.enliven360.com/storemgtapp
  const pluginAppRoute: string = currentPluginAppRoutePieces.slice(1).join('/'); // ie) stores/edit/123-abc
  if (pluginAppRoute) {
    iframeUrl += `?${REFRESH_QUERY_PARAM}=${pluginAppRoute}`; // ie) https://app.d.enliven360.com/storemgtapp?path=stores/edit/123-abc
  } else if (pluginAppDeepLink) {
    iframeUrl += `?${pluginAppDeepLink}`; // ie) https://app.d.enliven360.com/storemgtapp?function=viewdetails&id=<announcementid>
  }

  return of(iframeUrl);
};
